export default __webpack_public_path__ + "static/media/apple-QR.d90c9b66.png";